
/**
 * 公共接口
 */

const ajaxUrl = {
    dissTest: `/diss/test`,
    getRegisterPatientInfo: `/loss/patient/getRegisterPatientInfo`,//患者详情查询
    /**-------第三方------- */
    getAauth2AccessToken: `/third/wx/getAauth2AccessToken`,//公众号用code获取oauth2的accessToken
    getWxMaUser: `/third/wx/getWxMaUser`,//小程序根据jsCode获取用户信息sessionKey和openid、unionid
    getScheme: `/third/wx/getScheme`,//获取小程序跳转链接
}

export default ajaxUrl
